module.exports = __webpack_public_path__ + "media/slots_gold_country_ambience.9c43c085.mp3";